import React, { Component } from 'react'
import { KnowledgeMap } from '../../components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as knowledgeMapActionCreators from '../../redux/modules/knowledgeMap'
import { db } from '../../config/firebaseconfig'
import arrayify from '../../helpers/arrayify'
import saveParentChildNodes from '../../helpers/saveParentChildNodes'
import getNodesNotParentsOrChildren from '../../helpers/getNodesNotParentsOrChildren'

const uuid = require('uuid/v1')
const forOwn = require('mout/object/forOwn')

/*

there is a bug where the first letter I type in NodeInfo isn't showing up, but it's triggering new props.

*/

class KnowledgeMapContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      activeNodeName: '',
      nodeShortDescription: '',
      nodeLongDescription: '',
      addChildVal: '',
      addParentVal: '',
      nodeCode: '',
      nodeSource: '',
      search: '',
    }

    this.handleChange = this.handleChange.bind(this)
    this.saveChanges = this.saveChanges.bind(this)
    this.addNewNode = this.addNewNode.bind(this)
    this.saveParentChild = this.saveParentChild.bind(this)
    this.removeParentChild = this.removeParentChild.bind(this)
    this.deleteNode = this.deleteNode.bind(this)
    this.focusNameInput = this.focusNameInput.bind(this)
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  componentDidMount() {
    // checks the URL and sees if needs to display active node
    if (this.props.match.params.activeNode) {
      this.props.setActiveNode(this.props.match.params.activeNode)
    }


    // sets up a listener on nodes in store
    this.props.fetchingNodes()
    this.unsubscribe = db.collection('knowledgeMapNodes').onSnapshot(
      (querySnapshot) => {
        let nodes = {}
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          if (data.id) {
            nodes[data.id] = data
          }
        })
        this.props.fetchingNodesSuccess(nodes)
        if (this.props.activeNode) {
          this.setState({
            activeNodeName: this.props.nodes[this.props.activeNode] ? this.props.nodes[this.props.activeNode].name : '',
            nodeShortDescription: this.props.nodes[this.props.activeNode] ? this.props.nodes[this.props.activeNode].description.shortDescription : '',
            nodeLongDescription: this.props.nodes[this.props.activeNode] ? this.props.nodes[this.props.activeNode].description.longDescription : '',
            nodeCode: this.props.nodes[this.props.activeNode] ? this.props.nodes[this.props.activeNode].code : '',
            nodeSource: this.props.nodes[this.props.activeNode] ? this.props.nodes[this.props.activeNode].source : '',
            addChildVal: '',
            addParentVal: '',
          })
        }
      }, 
      (error) => this.props.fetchingNodesError(error))

  }

  componentWillReceiveProps(nextProps) {
    // checks the URL and sees if needs to display active node
    if (this.props.match.params.activeNode && nextProps.match.params.activeNode) {
      if (nextProps.match.params.activeNode !== this.props.match.params.activeNode) {
        this.props.setActiveNode(nextProps.match.params.activeNode)
      }
    } else if (!this.props.match.params.activeNode && nextProps.match.params.activeNode) {
      this.props.setActiveNode(nextProps.match.params.activeNode)
    } else if (this.props.match.params.activeNode && !nextProps.match.params.activeNode) {
      this.props.setActiveNode('')
    }

    if (nextProps.activeNode && nextProps.nodes && this.props.isChanged === nextProps.isChanged) {
      this.setState({
        activeNodeName: nextProps.nodes[nextProps.activeNode] ? nextProps.nodes[nextProps.activeNode].name : '',
        nodeShortDescription: nextProps.nodes[nextProps.activeNode] ? nextProps.nodes[nextProps.activeNode].description.shortDescription: '',
        nodeLongDescription: nextProps.nodes[nextProps.activeNode] ? nextProps.nodes[nextProps.activeNode].description.longDescription : '',
        nodeCode: nextProps.nodes[nextProps.activeNode] ? nextProps.nodes[nextProps.activeNode].code : '',
        nodeSource: nextProps.nodes[nextProps.activeNode] ? nextProps.nodes[nextProps.activeNode].source : '',
        addChildVal: '',
        addParentVal: '',
      }) 
    }
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    }, () => {
      if (!this.props.isChanged) {
        this.props.nodeChanged()
      }
    })
  }

  saveChanges() {
    if (this.props.activeNode && this.props.nodes) {
      this.props.savingNode()
      let nodeToSave = this.props.nodes[this.props.activeNode]
      nodeToSave.name = this.state.activeNodeName
      nodeToSave.description = {
        shortDescription: this.state.nodeShortDescription,
        longDescription: this.state.nodeLongDescription,
      }
      nodeToSave.source = this.state.nodeSource
      nodeToSave.code = this.state.nodeCode
      db.collection('knowledgeMapNodes').doc(this.props.activeNode).set(nodeToSave)
        .then( () => this.props.savingNodeSuccess(nodeToSave))
        .catch( (error) => this.props.savingNodeError(error))
    } else {
      console.log('saveChanges() error at KnowledgeMapContainer component')
    }
  }

  addNewNode() {
    this.props.creatingNewNode()
    const id = uuid()
    const newNode = {
      children: null,
      source: '',
      code: '',
      description: {
        shortDescription: '',
        longDescription: '',
      },
      exemplarItems: null,
      id,
      matchedItems: null,
      name: 'New Node',
      parents: null,
    }
    db.collection('knowledgeMapNodes').doc(id).set(newNode)
      .then(() => {
        this.props.creatingNewNodeSuccess(newNode.id)
        this.focusNameInput()
      })
      .catch((error) => this.props.creatingNewNodeError(error))
  }

  removeParentChild(parentQ, id) {
    this.props.savingNode()
    let parentOrChild
    let recipParentOrChild
    if (parentQ) {
      parentOrChild = 'parents'
      recipParentOrChild = 'children'
    } else {
      parentOrChild = 'children'
      recipParentOrChild = 'parents'
    }
    
    let nodeToEdit = this.props.nodes[this.props.activeNode][parentOrChild]
    nodeToEdit[id] = false

    let reciprocalNodeToEdit = this.props.nodes[id][recipParentOrChild]
    reciprocalNodeToEdit[this.props.activeNode] = false


    const batch = db.batch()
    const nodeToEditRef = db.collection('knowledgeMapNodes').doc(this.props.activeNode)
    const reciprocalNodeToEditRef = db.collection('knowledgeMapNodes').doc(id)
    batch.set(nodeToEditRef, {[parentOrChild]: nodeToEdit}, {merge: true})
    batch.set(reciprocalNodeToEditRef, {[recipParentOrChild]: reciprocalNodeToEdit}, {merge: true})
    batch.commit()
      .then( () => this.props.savingNodeSuccess())
      .catch( (err) => this.props.savingNodeError(err))
   
  }

  saveParentChild(relType) {
    if (relType === 'Parent') {
      // this.saveChanges() might cause issues here as a fix because async
      this.saveChanges()
      this.props.savingNode()
      let parents = this.props.nodes[this.props.activeNode].parents
      parents
      ? parents[this.state.addParentVal] = true
      : parents = {[this.state.addParentVal]: true}
      
      let children = this.props.nodes[this.state.addParentVal].children
      children
      ? children[this.props.activeNode] = true
      : children = {[this.props.activeNode]: true}

      saveParentChildNodes({
        db,
        settingParentQ: true,
        thisNodeId: this.props.activeNode,
        thisNodeData: parents,
        reciprocalNodeId: this.state.addParentVal,
        reciprocalNodeData: children,
        successFunc: this.props.savingNodeSuccess,
        errorFunc: this.props.savingNodeError,
      })
    } else if (relType === 'Child') {
      // this.saveChanges() might cause issues here as a fix because async
      this.saveChanges()
      this.props.savingNode()
      let children = this.props.nodes[this.props.activeNode].children
      children
      ? children[this.state.addChildVal] = true
      : children = {[this.state.addChildVal]: true}

      let parents = this.props.nodes[this.state.addChildVal].parents
      parents
      ? parents[this.props.activeNode] = true
      : parents = {[this.props.activeNode]: true}

      saveParentChildNodes({
        db,
        settingParentQ: false,
        thisNodeId: this.props.activeNode,
        thisNodeData: children,
        reciprocalNodeId: this.state.addChildVal,
        reciprocalNodeData: parents,
        successFunc: this.props.savingNodeSuccess,
        errorFunc: this.props.savingNodeError,
      })
    }
  }

  deleteNode() {
    if (this.props.activeNode) {
      this.props.savingNode()

      /*
        Turn all references to the node to false (parents and children)
      */

      const batch = db.batch()
      db.collection('knowledgeMapNodes').where(`parents.${this.props.activeNode}`, '==', true).get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const key = `parents.${this.props.activeNode}`
            batch.update(doc.ref, {[key]: false}) 
          })
          db.collection('knowledgeMapNodes').where(`children.${this.props.activeNode}`, '==', true).get()
            .then((qS) => {
              qS.forEach((doc) => {
                const k = `children.${this.props.activeNode}`
                batch.update(doc.ref, {[k]: false})
              })
              const thisNode = db.collection('knowledgeMapNodes').doc(this.props.activeNode)
              batch.delete(thisNode)
              batch.commit()
                .then(() => {
                  this.props.savingNodeSuccess()
                  this.props.history.push('/content/knowledge-map')
                })
                .catch((err) => this.props.savingNodeError(err))
            })
            .catch((err) => this.props.savingNodeError(err))
        })
        .catch((err) => this.props.savingNodeError(err))

        /*
      db.collection('knowledgeMapNodes').doc(this.props.activeNode).delete()
        .then(() => {
          this.props.savingNodeSuccess()
          this.props.history.push('/content/knowledge-map')
        })
        .catch((err) => this.props.savingNodeError(err))
    }
*/

    }
  }

  focusNameInput() {
    this.nameInput.select()
  }


  render() {
    /* Calculate and send down the active node and parents and children nodes objects */
    let activeNode = null
    let childrenNodes = null
    let parentNodes = null
    let nonChildrenNodes = null
    let nonParentNodes = null
    let nonParentOrChildrenNodes = null
    if (this.props.nodes && this.props.activeNode) {
      if (this.props.nodes[this.props.activeNode]) {
        activeNode = this.props.nodes[this.props.activeNode]
        if (activeNode.children) {
          const childrenNodesKeys = Object.keys(activeNode.children)
          childrenNodes = {}

          childrenNodesKeys.forEach( (childrenNodesKey) => {
            if (activeNode.children[childrenNodesKey]) {
              childrenNodes[childrenNodesKey] = this.props.nodes[childrenNodesKey]
            }
          })
        } 

        if (activeNode.parents) {
          const parentNodesKeys = Object.keys(activeNode.parents)
          parentNodes = {}
          parentNodesKeys.forEach((parentNodesKey) => {
            if (activeNode.parents[parentNodesKey]) {
              parentNodes[parentNodesKey] = this.props.nodes[parentNodesKey]
            }
          })
        }

        nonParentOrChildrenNodes = getNodesNotParentsOrChildren(activeNode, this.props.nodes)
      }
    }

    let searchedRows = this.props.nodes
    if (this.state.search) {
      searchedRows = {}
      forOwn(this.props.nodes, (val, key, o) => {
        if (val.name.toLowerCase().search(this.state.search.toLowerCase()) !== -1 || key === this.props.activeNode) {
          searchedRows[key] = val
        }
      })
    }


    return (
      <KnowledgeMap 
        nodes={this.props.nodes}
        activeNode={activeNode}
        error={this.props.error}
        isFetching={this.props.isFetching}
        childrenNodes={childrenNodes}
        parentNodes={parentNodes}
        setActiveNode={this.props.setActiveNode}
        handleChange={this.handleChange}
        activeNodeName={this.state.activeNodeName}
        nodeLongDescription={this.state.nodeLongDescription}
        nodeShortDescription={this.state.nodeShortDescription}
        isChanged={this.props.isChanged}
        saveChanges={this.saveChanges}
        addNewNode={this.addNewNode}
        nonParentNodes={nonParentOrChildrenNodes}
        nonChildrenNodes={nonParentOrChildrenNodes}
        addParentVal={this.state.addParentVal}
        addChildVal={this.state.addChildVal}
        saveParentChild={this.saveParentChild}
        removeParentChild={this.removeParentChild}
        deleteNode={this.deleteNode}
        nodeCode={this.state.nodeCode}
        nodeSource={this.state.nodeSource}
        search={this.state.search}
        searchedRows={searchedRows}
        nameRef={(input) => { this.nameInput = input}}
      />
    )
  } 
}

export default connect(
  (state) => ({
    nodes: state.knowledgeMap.nodes,
    error: state.knowledgeMap.error,
    isFetching: state.knowledgeMap.isFetching,
    activeNode: state.knowledgeMap.activeNode,
    isChanged: state.knowledgeMap.isChanged,
  }),
  (dispatch) => bindActionCreators(knowledgeMapActionCreators, dispatch)
)(KnowledgeMapContainer)


// WEBPACK FOOTER //
// ./src/containers/Content/KnowledgeMapContainer.js